import CareGiving from "../../../assets/images/CareGiving.jpg";
import CareGiving1 from "../../../assets/images/CareGiving1.jpg";
import CareGiving2 from "../../../assets/images/CareGiving2.jpg";
import AgeAtHome from "../../../assets/images/AgeatHome.jpg";
import SeniorCare from "../../../assets/images/SeniorCare.jpg";
import SeniorCare1 from "../../../assets/images/SeniorCare1.jpg";
import Age from "../../../assets/images/pexels-cottonbro-4057763(1).avif";
import Age1 from "../../../assets/images/pexels-expect-best-1243332.avif";
import Age2 from "../../../assets/images/pexels-monica-silvestre-1034597 (1).avif";
import Age3 from "../../../assets/images/pexels-denys-gromov-4661931.avif";
import Age4 from "../../../assets/images/pexels-pixabay-34761 (1).avif";
import Age5 from "../../../assets/images/pexels-askar-abayev-5638644.avif";
import Age6 from "../../../assets/images/pexels-paul-theodor-oja-2769001 (1).avif";
import Age7 from "../../../assets/images/pexels-elevate-3009797 (1).avif";
import Age8 from "../../../assets/images/pexels-dimitri-dim-1845844 (1).avif";
import Age9 from "../../../assets/images/pexels-tristan-le-1653898 (1).avif";
import Age10 from "../../../assets/images/pexels-magda-ehlers-1307391 (1).avif";
import Age11 from "../../../assets/images/pexels-italo-melo-1786244 (1).avif";
import Age12 from "../../../assets/images/pexels-daria-obymaha-1684916 (1).avif";

export const blogData = [
  {
    id: "0",
    category: "Care Giving",
    image: CareGiving,
    categoryItems: [
      {
        id: "0",
        image: CareGiving,
        title: "Delivering Bad News to an Elderly Person",
        subTitle:
          "MIHYGGE > AGE AT HOME - COMMUNITY SUPPORT & SERVICES > DELIVERING BAD NEWS TO AN ELDERLY PERSON",
        tag: "bad news, Elderly, Senior Care, Senior Living, Seniors",
        details:
          "News can be as easy, hard, or unknown as it is to the giver of the news so is to the receiver of the news. For the giver was once a receiver and the receiver was once a giver. It is one of those moments, where one does not want to be, having been there before or having watched it somehow. Our imagination, our human brains is intricate, unique, and subject to various stimuli. The stimuli are what makes us fear, fear of being rejected, harmed, hurt, unloved and so much more. What if this were us and the news was to be delivered to an elderly person? This is especially difficult when delivering bad news to an elderly person with cognitive issues. In my personal journeys and experiences, I came across thousands of such opportunities and times where it either brought us closer or sent us further into the known and the unknown.",
        date: "2020-11-01",
        link: "/series",
        link: "https://blog.mihygge.com/delivering-bad-news-to-an-elderly-person/",
        blogCategory: "Care Giving",
        author: "Dr Purnima",
      },
      {
        id: "1",
        image: CareGiving1,
        title:
          "Why Efficiency Matters in Finding the Best Senior Care for Your Beloved Senior?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > WHY EFFICIENCY MATTERS IN FINDING THE BEST SENIOR CARE FOR YOUR BELOVED SENIOR?",
        tag: "Senior Care, Senior Citizens, Senior Home Care, Senior Living, Seniors",
        details:
          "Why old rules don’t work? Why changes in technology are making it easier day by day for all humans in many aspects to avail of opportunities? As humans are longing for efficiency and efficient systems are here to stay. Certainly, the aging population will reach new heights by 2030 and even more so by 2050 worldwide. The mortality rates are declining and humans are living longer, thanks to scientific advances all over the globe.",
        date: "2020-25-01",
        link: "https://blog.mihygge.com/why-efficiency-matters-in-finding-the-best-senior-care-for-your-beloved-senior/",
        blogCategory: "Care Giving",
        author: "Dr Purnima",
      },
      {
        id: "2",
        image: CareGiving2,
        title: "Why Efficiency Matters in Senior Caregiving?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > WHY EFFICIENCY MATTERS IN SENIOR CAREGIVING?",
        tag: "Caregiving, Senior Care, Senior Home Care, Senior Living, Seniors",
        details:
          "There is no one set of rules that defines a caregiver. In some countries, they are referred to as caretakers or carers…Caregivers are more often family or friends or neighbors than other people from the communities.",
        date: "2020-02-02",
        link: "https://blog.mihygge.com/why-efficiency-matters-in-senior-caregiving/",
        blogCategory: "Care Giving",
        author: "Dr Purnima",
      },
    ],
  },

  {
    id: "1",
    category: "Age at Home",
    image: AgeAtHome,
    categoryItems: [
      {
        id: "0",
        image: AgeAtHome,
        title:
          "To Receive the Best Senior Care, One Must Do For Their Aging Family Member?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Caregivers, Caregiving, Senior Care, Seniors",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-18-01",
        link: "https://blog.mihygge.com/to-receive-the-best-senior-care-one-must-for-their-aging-family-member/",
        blogCategory: "Age at Home",
        author: "Dr Purnima",
      },
    ],
  },

  {
    id: "2",
    category: "Senior Care",
    image: SeniorCare,
    categoryItems: [
      {
        id: "0",
        title:
          "How to Form a Valuable Friendship with an Elderly with Declining Cognitive Abilities?",
        subTitle:
          "MIHYGGE > CARE GIVING - PRIMER FOR NEWCOMERS > HOW TO FORM A VALUABLE FRIENDSHIP WITH AN ELDERLY WITH DECLINING COGNITIVE ABILITIES?",
        image: SeniorCare,
        tag: "Caregiving, Cognition, Friendship, Senior Care",
        details:
          "Friendship goes beyond boundaries, some lasting a lifetime or generations! Friendship is the essence of our very social survival, creativity, and core values. Friendship is part of our history, culture, heritage and so much more. Why does friendship then wane when one person in the equation is not cognitively sound anymore? Or does it? Today we explore ways to challenge ourselves and begin a new conversational series from miHygge. ",
        date: "2020-08-02",
        link: "https://blog.mihygge.com/how-to-form-a-valuable-friendship-with-an-elderly-with-declining-cognitive-abilities/",
        blogCategory: "Senior Care",
        author: "Dr Purnima",
      },
      {
        id: "1",
        image: SeniorCare1,
        title:
          "Benefits of Preparing a Discharge Plan for Hospitalized Seniors",
        subTitle:
          "MIHYGGE > ASSESSMENT & INFORMATION - SENIOR CARE - UNCATEGORIZED > BENEFITS OF PREPARING A DISCHARGE PLAN FOR HOSPITALIZED SENIORS",
        tag: "Discharge plan for elderly, hospitalization of elderly, Aging, Aging Parents, Aging Well, Caregiving, Healthcare, Senior Care, Senior Citizens, Senior Home Care, Senior Living, Seniors",
        details:
          "During my decades of practice in geriatrics, I came across numerous scenarios of people needing information on post discharge planning. While seniors and families were helped immensely by Social Services, resources at the hospital where people were discharged either to their own homes or to senior living facilities or communities with home health, home care, hospice or rehabilitation, there were a lot of questions and issues I had to figure out, plan, solve, and help proactively with forward thinking.",
        date: "2020-22-02",
        link: "https://blog.mihygge.com/benefits-of-preparing-a-discharge-plan-for-hospitalized-seniors-2/",
        blogCategory: "Senior Care",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "3",
    category: "Assessment & Information, Senior Care, Uncategorized",
    image: Age,
    categoryItems: [
      {
        id: "0",
        image: Age,
        title: "What Ways Do Seniors Cope with Memory Loss?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging, Aging Parents, Aging Well, Caregiving, Discharge plan for elderly, Healthcare, hospitalization of elderly, Senior Care, Senior Citizens, Senior Home Care, Senior Living, Seniors",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-22-02",
        link: "https://blog.mihygge.com/what-ways-do-seniors-cope-with-memory-loss/",
        blogCategory: "Assessment & Information, Senior Care, Uncategorized",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "4",
    category: "Life’s simple pleasures, Simple Living & Positive Thinking",
    image: Age1,
    categoryItems: [
      {
        id: "0",
        image: Age1,
        title: "Why We Need More Choices to Make Better Decisions",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging, Aging Parents, Senior Care, Senior Home Care, Senior Living",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-21-03",
        link: "https://blog.mihygge.com/why-we-need-more-choices-to-make-better-decisions/",
        blogCategory:
          "Life’s simple pleasures, Simple Living & Positive Thinking",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "5",
    category: "General",
    image: Age2,
    categoryItems: [
      {
        id: "0",
        image: Age2,
        title:
          "The List that Keeps Growing… Why a Box Does Not Answer All Elderly Questions?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging, Aging Parents, Senior Care, Senior Home Care, Senior Living",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-28-03",
        link: "https://blog.mihygge.com/the-list-that-keeps-growing-why-a-box-does-not-answer-all-elderly-questions/",
        blogCategory: "General",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "6",
    category: "As a Child…",
    image: Age3,
    categoryItems: [
      {
        id: "0",
        image: Age3,
        title: "How to Tell Your Parents it’s Time to Find Some Help?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging in Place, Aging Parents, Family, Healthcare, Home Nursing Services",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-11-04",
        link: "https://blog.mihygge.com/how-to-tell-your-parents-its-time-to-find-some-help/",
        blogCategory: "As a Child…",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "7",
    category: "As a Child…, Care Giving",
    image: Age4,
    categoryItems: [
      {
        id: "0",
        image: Age4,
        title: "When One Parent Decides Against the Wishes of the Other",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging Parents, Care Taking, Caregiving, Caretakers, Marriage",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-18-04",
        link: "https://blog.mihygge.com/when-one-parent-decides-against-the-wishes-of-the-other/",
        blogCategory: "As a Child…, Care Giving",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "8",
    category: "Care Giving, For Health and Well-Being",
    image: Age5,
    categoryItems: [
      {
        id: "0",
        image: Age5,
        title: "Senior Well Being and Health",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Health, Senior Care, Senior Health, Seniors, Well Being",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-25-04",
        link: "https://blog.mihygge.com/senior-well-being-and-health/",
        blogCategory: "Care Giving, For Health and Well-Being",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "9",
    category: "Care Giving, Senior Care",
    image: Age12,
    categoryItems: [
      {
        id: "0",
        image: Age12,
        title:
          "Working at Home While Caring for an Elderly with Cognitive Challenges",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging, Aging Parents, Aging Well, Caregiving, Healthcare, Senior Care, Senior Citizens, Senior Home Care, Senior Living, Seniors",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-06-05",
        link: "https://blog.mihygge.com/working-at-home-while-caring-for-an-elderly-with-cognitive-challenges-2/",
        blogCategory: "Care Giving, Senior Care",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "10",
    category: "Hobbies & Events, Life’s simple pleasures",
    image: Age6,
    categoryItems: [
      {
        id: "0",
        image: Age6,
        title: "What Hobbies Are Great to Continue?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Hobbies and Interests, Passtimes, Senior Citizens, Senior Living, Seniors",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-09-05",
        link: "https://blog.mihygge.com/what-hobbies-are-great-to-continue/",
        blogCategory: "Hobbies & Events, Life’s simple pleasures",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "11",
    category: "Age at Home, Finances & Planning",
    image: Age7,
    categoryItems: [
      {
        id: "0",
        image: Age7,
        title:
          "What Can Be Done by Families to Help the Elderly Plan for Their Future?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Age at Home, Caregiving, Future, Planning, Senior Care",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-16-05",
        link: "https://blog.mihygge.com/what-can-be-done-by-families-to-help-the-elderly-plan-for-their-future/",
        blogCategory: "Age at Home, Finances & Planning",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "12",
    category: "Age at Home, Healthy Aging",
    image: Age8,
    categoryItems: [
      {
        id: "0",
        image: Age8,
        title: "Aging Health Education, 21st century and Beyond",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging, Aging Well, Senior Care, Senior Citizens, Senior Home Care, Senior Living, Seniors",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-23-05",
        link: "https://blog.mihygge.com/aging-health-education-21st-century-and-beyond/",
        blogCategory: "Age at Home, Healthy Aging",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "13",
    category: "Life’s simple pleasures, Mental Well Being",
    image: Age9,
    categoryItems: [
      {
        id: "0",
        image: Age9,
        title: "Living in the Moment…miHygge",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging Well, Life, Mindfulness, Seniors, Simple Pleasures, Well Being",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-06-06",
        link: "https://blog.mihygge.com/living-in-the-momentmihygge/",
        blogCategory: "Life’s simple pleasures, Mental Well Being",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "14",
    category: "Care Giving, General",
    image: Age10,
    categoryItems: [
      {
        id: "0",
        image: Age10,
        title: "Knowing an Assisted Living Community or Facility or Home",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Assisted Living, Nursing Homes, Senior Living, Senior Living Communities",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-13-06",
        link: "https://blog.mihygge.com/knowing-an-assisted-living-community-or-facility-or-home/",
        blogCategory: "Care Giving, General",
        author: "Dr Purnima",
      },
    ],
  },
  {
    id: "15",
    category: "Age at Home, Independent Home",
    image: Age11,
    categoryItems: [
      {
        id: "0",
        image: Age11,
        title: "Is Senior Care at Home Right for You?",
        subTitle:
          "MIHYGGE > CARE GIVING - GENERAL > TO RECEIVE THE BEST SENIOR CARE, ONE MUST? FOR THEIR AGING FAMILY MEMBER?",
        tag: "Aging, Healthcare, Home Health Care, In Home Senior Care, Senior Care",
        details:
          "What does one mean by best senior care? Most of the companies provide similar senior care, however their hourly rates, may differ, or their specialty may be a thing or two. In senior living, it is the same, the smaller facilities are more homelike, offer a more personalized care and may specialize in something vs a larger facility which has access to more resources, and may or may not translate to the ratio of caregivers to the senior. The pricing can vary depending on needs, availabilities… So what should one do to help their senior receive the best care… Now that you have moved them to a senior care facility or home, or have those sharing their home with someone?",
        date: "2020-20-06",
        link: "https://blog.mihygge.com/is-senior-care-at-home-right-for-you/",
        blogCategory: "Age at Home, Independent Home",
        author: "Dr Purnima",
      },
    ],
  },
];
